import React from 'react';
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import EligibilityChecker from "../components/Eligibility/EligibilityChecker";

const EligibilityPage = () => {
    return (
        <>
            <div className="bg-[#0f172a] overflow-hidden">
                <Navbar />
                <EligibilityChecker />
                <Footer />
            </div>
        </>
    );
};

export default EligibilityPage;
